// extracted by mini-css-extract-plugin
export default {"forbidden":"Forbidden_forbidden__u8SNa","lock":"Forbidden_lock__uHVGB","dip":"Forbidden_dip__CHP0c","spin":"Forbidden_spin__tR07q","message":"Forbidden_message__Vb8Sd"};